'use client'
import CMButton from '@/components/layout/buttons/cmButton'
import { GeneralLayout, HeaderLayout } from '@/payload-types'
import SocialMediaLink from '@/components/layout/social-link/social-link'
import { SocialLinkItem } from '@/components/layout/social-link/social-link'
import { reportIncidentSvg, reportIndividualSvg } from '../main-navigation'

interface IProps {
  header?: HeaderLayout
  general?: GeneralLayout
}
const SideBarBottomSecion = ({ header, general }: IProps) => {
  return (
    <>
      <div className="w-full flex flex-col absolute mt-auto bottom-[60px]">
        <div className="py-[10px] px-[18px]">
          {header?.reportIndicident && (
            <CMButton
              buttonType="reportIndividualButton"
              buttonText="REPORT AN INDIVIDUAL"
              href="/report_an_individual"
              link={true}
              className="reportIndividualSidebar"
              target={false}
            >
              <div className={'mr-1'}>{reportIndividualSvg}</div>
            </CMButton>
          )}
          {header?.reportIndicident && (
            <CMButton
              buttonType="reportIndividualButton"
              buttonText="REPORT AN EVENT"
              href="/report_an_event"
              link={true}
              className="reportIndividualSidebar"
              target={false}
            >
              <div className={'mr-1'}>{reportIncidentSvg}</div>
            </CMButton>
          )}
        </div>
        <div className="h-[0.5px] bg-[#E1E1E1] w-full"></div>
        <div className="relative right-[5px] flex flex-row h-full w-full items-center justify-around">
          <div className="flex">
            {header?.socialMediaLink &&
              general?.socialMediaLinks?.map((item: SocialLinkItem) => (
                <div className="!p-[15px]" key={item.id}>
                  <SocialMediaLink
                    socialLink={{ link: item.link, platform: item.platform, id: item.id }}
                    width={19}
                    height={19}
                    key={item.link}
                    className="w-[19px] h-[19px]"
                  />
                </div>
              ))}
          </div>
          {header?.donateButton && (
            <CMButton
              buttonType="donateButton"
              buttonText="DONATE"
              href="https://buy.stripe.com/28obJ72az6zz5cQ5kv"
              link={true}
              className="donate"
              target={true}
            />
          )}
        </div>
      </div>
    </>
  )
}
export default SideBarBottomSecion
